import React, { ChangeEvent, useId } from 'react';
import { Composite } from '../../structure/composite';
import { Label, Input, Slider, LabelText } from './switch.styles';

export interface SwitchProps extends Omit<
    React.InputHTMLAttributes<HTMLInputElement>,
    'onChange' | 'type'
> {
    label?: string;
    name: string;
    disabled?: boolean;
    value?: string;
    reverse?: boolean;
    onChange?: (value: boolean) => void;
    children?: React.ReactNode;
    justify?: string;
}

export function Switch({
    label,
    name,
    disabled,
    onChange = () => {},
    value,
    checked,
    children,
    reverse = false,
    justify,
    id,
    ...inputProps
}: SwitchProps) {
    const onValueChange = (event: ChangeEvent<HTMLInputElement>) => {
        onChange(event.target.checked);
    };

    // The label needs something to point at. Callers may pass their own id; the
    // generated one only has to be unique within the document.
    const generatedId = useId();
    const inputId = id ?? generatedId;

    return (
        <Composite reverse={reverse} justify={justify}>
            <Label data-test-id={name}>
                <Input
                    id={inputId}
                    type="checkbox"
                    disabled={disabled}
                    name={name}
                    value={value}
                    onChange={onValueChange}
                    checked={checked}
                    {...inputProps}
                />

                <Slider />
            </Label>
            {label && <LabelText htmlFor={inputId}>{label}</LabelText>}
            {children && children}
        </Composite>
    );
}
